import { createAction } from 'redux-actions'

export const setInitialCarFaxSuccess = createAction('SERVICE_HISTORY_PAGE/SET_INITIAL_CAR_FAX_SUCCESS')
